import { provideTranslateService } from "@ngx-translate/core";
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";

export const translateServiceProvider = provideTranslateService({
    fallbackLang: "en-US",
    loader: provideTranslateHttpLoader({
        prefix: "i18n/",
        suffix: ".json",
    }),
});
